/**
 * @Description 机会点详情-跟进记录内容区
 */
import { FC } from 'react';
import { dateFns, isArray } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import V2Empty from '@/common/components/Data/V2Empty';
import V2DetailGroup from '@/common/components/Feedback/V2DetailItem/Group';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import V2LogRecord from '@/common/components/SpecialBusiness/V2LogRecord';
import styles from './FollowRecordDrawer.module.less';

interface FollowRecordContentProps {
  mainHeight?: number;
  records: any[];
}

/** 机会点跟进记录内容区，由 V2Container 自动注入可用高度。 */
const FollowRecordContent: FC<FollowRecordContentProps> = ({
  mainHeight,
  records,
}) => {
  const methods = useMethods({
    /** 将跟进记录转换为时间线组件所需的数据结构。 */
    getLogRecordItems() {
      return records.map((item) => {
        const imageAssets = isArray(item?.fileList) ? item.fileList.map((url) => ({
          url,
          name: '',
        })) : [];

        return {
          date: dateFns.changeTime(item?.communicateAt, '-', true) || item?.communicateAt,
          status: 'finish',
          children: [{
            name: '',
            description: <div className={styles.followRecordDescription}>
              <div className={styles.followRecordName}>{item?.name}</div>
              <div className={styles.followRecordText}>{item?.content}</div>
              {!!imageAssets.length && <V2DetailGroup
                moduleType='easy'
                className='mb-12'
              >
                <V2DetailItem
                  type='images'
                  assets={imageAssets}
                  noStyle
                />
              </V2DetailGroup>}
            </div>,
          }],
        };
      });
    },

    /** 渲染机会点专用的跟进记录时间线。 */
    renderFollowRecords() {
      if (!records.length) {
        return <V2Empty
          className='mt-100'
          customTip='暂无记录'
        />;
      }

      return <V2LogRecord
        items={methods.getLogRecordItems()}
        type={2}
      />;
    },
  });

  return (
    <div
      className={styles.followRecordContent}
      style={{
        height: mainHeight,
        overflowY: 'auto',
      }}
    >
      {methods.renderFollowRecords()}
    </div>
  );
};

export default FollowRecordContent;
